<template>
    <svg xmlns="http://www.w3.org/2000/svg" 
        :fill="fillColor" 
        viewBox="0 0 24 24" 
        :class="svgClass"
    >
        <path fill-rule="evenodd" d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z" clip-rule="evenodd" />
    </svg>
</template>
  
  
    <script setup>
    import { defineProps, computed } from 'vue';
    
    const props = defineProps(['fill', 'iconClass'])

    const svgClass = computed(() => {
        return props.iconClass ? props.iconClass : 'w-5 h-5'
    })
    
    const fillColor = computed(() => {
        return props.fill ? props.fill : 'black'
    })

    
    </script>